import script from "./leftPie4.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie4.vue?vue&type=script&setup=true&lang=js"

import "./leftPie4.vue?vue&type=style&index=0&id=193ded42&scoped=true&lang=css"
script.__scopeId = "data-v-193ded42"

export default script